import React, { Fragment } from "react";
import PasTSummary from "./PasTSummary";

function PastTreatmentTr({ item, isMobile }: any) {
  if (item?.treatments.length === 0) return null;

  return (
    <Fragment>
      <PasTSummary item={item} isMobile={isMobile} />
    </Fragment>
  );
}

export default PastTreatmentTr;
